module.exports = __webpack_public_path__ + "static/media/trust-confirm.d084d1c9.png";